<template>
  <div>
    <h3 class="mb-5">Filter</h3>
    <div class="h4 my-5">
      Filter會顯示於Product SubCategory Page ;
      同SubCategory的產品將同步Filter種類
    </div>

    <!-- items -->
    <div
      class="form-item-last-no-border d-flex px-5 pt-5 py-1"
      v-if="subcategory.is_filter"
    >
      <div class="h4 w-100px mr-80px">子分類</div>
      <div class="ink-02-medium--text">
        <!--<div class="mb-10px" v-for="subitem in item.list" :key="subitem">-->
          <!--{{ subitem }}-->
        <!--</div>-->
      </div>
      <div class="ml-auto">
        <button class="chip"><span class="px-3">Subcategory</span></button>
      </div>
    </div>
    <!-- items -->
    <div
      class="form-item-last-no-border d-flex px-5 pt-5 py-1"
      v-for="(item, i) in filters"
      :key="i"
    >
      <div class="h4 w-100px mr-80px">{{ item.title }}</div>
      <div class="ink-02-medium--text">
        <div class="mb-10px" v-for="option in item.options" :key="option">
          {{ option.title }}
        </div>
      </div>
      <div class="ml-auto">
        <button class="chip">
          <span class="px-3" v-if="item.is_customized">Customized</span>
          <span class="px-3" v-else>From Spec</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
    ...mapGetters('subcategory', [
      'filters',
    ]),
  },
};
</script>

<style></style>
